import * as React from "react";
import "./DocStatusList.scss";

export interface DocStatusListProps {
  docName: string;
  docStatus: "Pending Upload" | "Approved" | "AUTO APPROVED" | "PENDING";
  docInfo: string;
}

const DocStatusList: React.FC<DocStatusListProps> = (props) => (
  <div className="docStatusList">
    <span className="docName">{props.docName}</span>
    <span
      className={
        "docStatus" +
        (/approved/i.test(props.docStatus || "")
          ? " approved"
          : /pending/i.test(props.docStatus || "")
            ? " pending"
            : "")
      }
    >
      {props.docStatus}
    </span>
    <span className="docInfo">{props.docInfo}</span>
  </div>
);

export default DocStatusList;
